// extracted by mini-css-extract-plugin
export default {"navbar_container":"Navbar_navbar_container__5DtR1","nav_item":"Navbar_nav_item__ccUrC"};